/** Base API URL from `VITE_APP_API_URL` (see `.env.development` / `.env.alpha` / `.env.production`). */
export function getApiUrl(): string {
  const apiUrl = import.meta.env.VITE_APP_API_URL?.trim();

  if (!apiUrl) {
    throw new Error(
      'VITE_APP_API_URL is not set. Add it to the .env file for your Vite mode (e.g. .env.development).'
    );
  }

  return apiUrl;
}
